/* eslint-disable no-await-in-loop */
import React from 'react';
import { DataSources } from '@leverege/ui-attributes';
import { Dialog, Toast } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('openApi.SaleJobService.RetrySaleJobs');

/**
 * Removes the userIds from the given action.
 */
async function onRetry({
  data
}) {
  // Get parameters
  const {
    targets,
    relationship,
    onClose,
    reloadData
  } = data;
  const blueprint = relationship?.blueprint;
  const num = targets.length;
  if (num === 0) {
    onClose();
    return;
  }
  let success = 0;
  let failure = 0;
  let err = null;
  for (let n = 0; n < num; n++) {
    try {
      const tgt = targets[n];
      const delegate = DataSources.getDelegate(tgt);
      const comms = delegate?.api.childComms;
      await comms.child('retry').post({
        incrementMaxRetries: true
      });
      success++;
    } catch (error) {
      failure++;
      if (err == null) {
        err = error;
      }
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
  const typeName = blueprint.getName(targets.length);
  if (failure === 0) {
    Toast.success(t('successTitle', {
      count: success,
      typeName
    }));
  } else if (success === 0) {
    Toast.error([t('errorTitle', {
      count: failure,
      typeName
    }), err.message]);
  } else {
    Toast.warn([t('warnTitle', {
      success,
      num,
      failure,
      typeName
    }), err.message]);
  }
  reloadData?.();
  onClose();
}

/**
 * Remove users dialog.
 */
export default function RetrySaleJobs(props) {
  // Get parameters
  const {
    onClose,
    show,
    targets,
    relationship
  } = props;
  const blueprint = relationship?.blueprint;
  const num = targets?.length || 0;
  const title = `${num} ${blueprint.getName(num)}`;
  const action = t('retry');

  // Render component
  return /*#__PURE__*/_jsx(Dialog.Question, {
    show: show,
    eventData: props,
    title: t('title', {
      title,
      action
    }),
    icon: blueprint.getIcon('deleteDialogIcon') || blueprint.getIcon('screenIcon'),
    message: t('message', {
      title
    }),
    okay: action,
    okayVariant: "primary",
    onCancel: onClose,
    onOkay: onRetry
  });
}